/**
 * @desc 父 -> iframe页面的iframe通信
 */
import PostMessage from '@umu/umu-post-message';
import { SessionMessageAction, IIframeMessageData } from '../messageActions';

export abstract class BasePostControlManager {
    public isInited: boolean = false;
    public postMessageInstance: PostMessage|undefined;
    public listeners: Array<(data: any) => void>;
    constructor() {
        this.listeners = [];
    }
    /**
     * 获取 domain 以设置 postmessage
     */
    abstract getDomain: () => string;
    /**
     * 初始化接收到数据的回调函数
     * @param {any} config domain, receiver, etc.
     */
    abstract init: (iframeEle?: HTMLIFrameElement) => void;
    public onMessage(listener: (data: any) => void) {
        if (!this.isInited) {
            return;
        }
        // 冗余一份，当iframe destroy的时候，可以支持再attach到新的iframe实例
        this.listeners.push(listener);
        this.postMessageInstance?.listen(listener);
    }
    public sendMsg(msg: IIframeMessageData<SessionMessageAction, any>) {
        this.postMessageInstance?.send({
            data: msg,
        } as any);
    }
    public sendGotoNext(payload?: any) {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.go_next_section,
            data: payload
        });
    }
    public sendGotoPrevious(payload?: any) {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.go_previous_section,
            data: payload
        });
    }
    public sendGoBackDirectory(payload?: any) {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.go_back_directory,
            data: payload
        });
    }
    /**
     * 页面销毁时注销掉事件
     */
    public destroy() {
        this.isInited = false;
        this.postMessageInstance?.destroy();
    }
};
